var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3 12c0-.5523.44772-1 1-1h8c.5523 0 1 .4477 1 1s-.4477 1-1 1h-8c-.55228 0-1-.4477-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 5c.55228 0 1 .44772 1 1v12c0 .5523-.44772 1-1 1s-1-.4477-1-1v-12c0-.55228.44772-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 5c.5523 0 1 .44772 1 1v12c0 .5523-.4477 1-1 1s-1-.4477-1-1v-12c0-.55228.4477-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.472 9.11833c.3251.17402.5281.51288.5281.88167v8c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6.1315l-1.4453.9636c-.4595.3063-1.0804.1821-1.3867-.2774-.3064-.4595-.1822-1.0804.2773-1.3867l3-2.00005c.3069-.20457.7014-.22364 1.0266-.04962z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeading);
export default __webpack_public_path__ + "static/media/heading.c3b0387d0732e7e890cb1f3ee67b7bb8.svg";
export { ForwardRef as ReactComponent };